import React from 'react'
import { useTranslation } from 'react-i18next'
import { LANGUAGES } from '../../i18n'

/* Inline SVG flags: consistent rendering on every OS (emoji flags don't
   render on Windows). preserveAspectRatio="slice" lets them fill the
   circular button. */
const FlagFR = () => (
    <svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <rect width="1" height="2" x="0" fill="#0055A4"/>
        <rect width="1" height="2" x="1" fill="#FFFFFF"/>
        <rect width="1" height="2" x="2" fill="#EF4135"/>
    </svg>
)

const FlagEN = () => (
    <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <rect width="60" height="30" fill="#012169"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2.5"/>
        <path d="M30,0 V30 M0,15 H60" stroke="#FFFFFF" strokeWidth="10"/>
        <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6"/>
    </svg>
)

const FlagMG = () => (
    <svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <rect width="1" height="2" x="0" fill="#FFFFFF"/>
        <rect width="2" height="1" x="1" y="0" fill="#FC3D32"/>
        <rect width="2" height="1" x="1" y="1" fill="#007E3A"/>
    </svg>
)

const FLAGS = { fr: FlagFR, en: FlagEN, mg: FlagMG }

// Flag buttons FR / EN / MG, always visible in the header
const LanguageSwitcher = () => {
    const { t, i18n } = useTranslation()
    const current = i18n.resolvedLanguage || i18n.language

    return (
        <div className="langSwitcher" role="group" aria-label={t('nav.chooseLanguage')}>
            {LANGUAGES.map(({ code, name }) => {
                const Flag = FLAGS[code]
                return (
                    <button
                        key={code}
                        type="button"
                        title={name}
                        aria-label={name}
                        className={`langOption ${current === code ? 'active' : ''}`}
                        aria-pressed={current === code}
                        onClick={() => i18n.changeLanguage(code)}
                    >
                        <Flag/>
                    </button>
                )
            })}
        </div>
    )
}

export default LanguageSwitcher
